import app from "../_app";

const nav = document.querySelector('.js-nav');

if(nav && app.viewport.isEqualOrSmallerThan('md')) {
    const triggers = [...document.querySelectorAll('.js-nav-trigger')];

    triggers.map(trigger => trigger.addEventListener('click', () => {
        if(nav.hasAttribute('data-open')) {
            nav.removeAttribute('data-open');
            app.unlockBody();
        } else {
            app.lockBody();
            nav.setAttribute('data-open', '');
        }
    }));
}
